import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

interface EditingLayoutsState {
    /** UUID of org that should be currently displayed or what will show if redirecting to the root */
    isEditingLayouts: boolean
}

export const useEditingLayoutsStore = create<EditingLayoutsState>()(
    devtools(
        (set) => ({
            isEditingLayouts: false,
        }),
        { name: 'EditingLayoutsStore' },
    ),
)

export const useIsEditingLayouts = () => useEditingLayoutsStore((state) => state.isEditingLayouts)
export const getIsEditingLayouts = () => useEditingLayoutsStore.getState().isEditingLayouts
export const setIsEditingLayouts = (state: boolean) => useEditingLayoutsStore.setState({ isEditingLayouts: state })
